<template>
  <transition :name="noTransition?'':'fade'">
    <div class="loading-wrap" v-if="show">
      <label class="loading-btn loading" :style="{color}"></label>
      <slot/>
    </div>
  </transition>
</template>

<script>
  export default {
    name: "Loading",
    props: {
      color: {
        default: 'rgba(54, 54, 54, 0.7)',
        type: String,
      },
      show: {
        default: false,
        type: Boolean,
      },

      noTransition: {
        default: false,
        type: Boolean
      }
    },
  }
</script>

<style scoped lang="scss">

  /*.fade-enter-active, .fade-leave-active*/

  .fade {
    &-enter-active, &-leave-active {
      transition: opacity .3s, height .3s;
    }

    &-enter, &-leave-to {
      opacity: 0;
      height: 0;
    }
  }

  .loading-wrap {
    display: block;
    width: 100%;
    height: 0.4rem;
    text-align: center;
    font-size: 0.14rem;
    .loading {
      display: inline-block;
      height: 0.4rem;
      width: 0.4rem;
      vertical-align: middle;
    }
  }

  /* 按钮loading */
  a[class*=-btn].loading,
  label[class*=-btn].loading {
    position: relative;
  }
  a[class*=-btn].loading::first-line,
  label[class*=-btn].loading::first-line {
    color: transparent;
  }
  a[class*=-btn].loading::before,
  label[class*=-btn].loading::before {
    width: 0.04rem; height: 0.04rem;
    margin: auto;
    content: '';
    -webkit-animation: spinZoom 1s steps(8) infinite;
    animation: spinZoom 1s steps(8) infinite;
    border-radius: 100%;
    box-shadow: 0 -10px 0 1px currentColor, 10px 0 currentColor, 0 10px currentColor, -10px 0 currentColor, -7px -7px 0 .5px currentColor, 7px -7px 0 1.5px currentColor, 7px 7px currentColor, -7px 7px currentColor;
    position: absolute;
    top: 0; right: 0; bottom: 0; left: 0;
  }
  /* loading动画 */
  @-webkit-keyframes spinZoom {
    0% {
      -webkit-transform: scale(.75) rotate(0);
    }
    100% {
     -webkit-transform: scale(.75) rotate(360deg);
    }
  }
  @keyframes spinZoom {
    0% {
      transform: scale(.75) rotate(0);
    }
    100% {
      transform: scale(.75) rotate(360deg);
    }
  }
</style>